const CONTACTUS_API =
  "https://www.dermaslimwellness.com/apis/ContactSubmissions.php";
const Login_api = "https://www.dermaslimwellness.com/apis/login.php";
const LEADS_API = "https://www.dermaslimwellness.com/apis/Leads.php";

export { CONTACTUS_API, Login_api,LEADS_API };
